import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  computed,
  input,
} from '@angular/core';
import { AccordionModule } from 'ui-elements/accordion';
import { ButtonLink, Faq, FaqQuestionAndAnswer, M2A } from 'www-cms';
import { LastItemBgClass } from '../../shell/shell.service';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { generateFaqId } from '../../shared/helpers/faq-id';
import { TextBlockComponent } from '../text-block/text-block.component';
import { ButtonLinkComponent } from 'building-blocks/button-link/button-link.component';
import { DirectusDirective } from 'directus';

@Component({
  selector: 'ss-www-faqs',
  imports: [
    CommonModule,
    AccordionModule,
    ButtonLinkComponent,
    TextBlockComponent,
    DirectusDirective,
  ],
  templateUrl: './faqs.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqsComponent extends BaseBuildingBlockComponent {
  faqData = input.required<Faq>();
  qAndAs = computed(() =>
    this.addQuestionId(this.faqData().questionsAndAnswers)
  );
  @Input() brownBg = false;

  identify(index: number, item: FaqQuestionAndAnswer) {
    return item.question;
  }

  buttons(index: number, item: M2A<ButtonLink>) {
    return item.item.id;
  }

  addQuestionId(qAndA: FaqQuestionAndAnswer[]) {
    return qAndA.map((faq) => {
      return {
        ...faq,
        id: generateFaqId(faq.question),
      };
    });
  }

  override getBgClass(): LastItemBgClass {
    if (this.brownBg) return 'bg-ss-darker-brown';
    return this.faqData().darkBackground ? 'bg-ss-www-background' : 'bg-white';
  }
}
